<template>
  <div>
  <b-list-group class="col-md-12 mt-3 ml-3 mb-2" >
    <b-list-group-item class="justify-content-between align-items-center">
      <div class="row">
        <div class="col-md-9 col-sm-9">
          <b>{{extensible.heading}}</b><br>
          <span class="badge badge-success badge-pill mr-2"><i class="icon-eye icons font-1xl"> {{extensible.total_views}}view{{extensible.total_views == 1 ? '':'s'}}</i></span>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="btn-group pull-right">
            <b-dropdown class="btn-group" variant="p-0" right no-caret>
              <template slot="button-content">
                <i class="icon-options-vertical icons font-1xl"></i>
              </template>
              <b-dropdown-item title="Send as SMS" v-b-tooltip.hover @click="handleSendAsSMS()"><i class="icon-paper-plane icons font-1xl"></i>Send as SMS</b-dropdown-item>
              <b-dropdown-item title="Reload" v-b-tooltip.hover @click="loadReviews()"><i class="icon-refresh icons font-1xl"></i>Reload</b-dropdown-item>
              <b-dropdown-item v-if="isMobileDevice" title="Share" @click="handleShare()"><i class="icon-share icons font-1xl"></i>Share</b-dropdown-item>
              <b-dropdown-item title="Delete" @click="handleMessageDelete()"><i class="icon-trash icons font-1xl"></i>Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </b-list-group-item>
    <b-list-group-item class="flex-column align-items-start">
      <div class="row p-3">
        <img v-if="extensible.media_type==2" class="media-size" :src="imageUrl+extensible.media_url"/>
         <audio class="media-size mb-3" controls v-else-if="extensible.media_type==4">
            <source :src="audioUrl+extensible.media_url" type="audio/mpeg">
            Your browser does not support the audio tag.
        </audio> 
         <video v-else-if="extensible.media_type==3" class="media-size mb-3" controls>
            <source :src="videoUrl+extensible.media_url" type="video/mp4">
            Your browser does not support the video tag.
        </video> 
        <div v-html="extensible.content"></div>
      </div>
      <span class="text-muted"><small><i class="icon-calendar icons font-1xl"> {{extensible.created_date}}</i></small></span>
      <br>
      <span class="text-muted"><small>
      <i class="icon-clock icons font-1xl"> {{extensible.created_time}}</i></small></span>
      <template v-if="extensible.subcode != '' && extensible.subcode != null">
        <div class="pt-2">
            <span class="badge badge-primary badge-pill mr-2"><i class='fa fa-rss'></i> {{getNewsletterNameBySubcode}}</span> 
        </div>
      </template>
    </b-list-group-item>
    <b-list-group-item class="flex-column align-items-start">
      <a target="_blank" :href="url+extensible.slug"> {{url+extensible.slug}}</a>
      <b-button class="pull-right" v-b-tooltip.hover title="Copy" variant="success"
                      v-clipboard:copy="url+extensible.slug"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onCopyError">Copy</b-button>
    </b-list-group-item>
  </b-list-group>
  <div v-if="extensible.review_requested">
    <b-list-group class="col-md-12 mt-3 ml-3 mb-3" >
      <b-list-group-item class="justify-content-between align-items-center">
        <div class="row">
          <div class="col-md-12">
            Rewiews ({{extensible.reviews.length}})
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item class="flex-column align-items-start">
        <div class="row p-1" v-for="(rewiewInfo, index) in extensible.reviews" :key="index+rewiewInfo.id">
          <div class="col-md-12">
          {{rewiewInfo.name}}<br>
          <span class="text-muted"><small>{{rewiewInfo.created_date}} {{rewiewInfo.created_time}}</small></span><br>
          {{rewiewInfo.review}}
          <hr style="border-top: 1px dashed rgba(0, 0, 0, 0.1) !important;">
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
  </div>
</template>

<script> 
import Vue from 'vue'
import { mapState, mapActions } from "vuex"
import {EventBus} from '@/events/bus.event'
import { isMobileDevice } from '@/shared/utils'

import { Plugins } from '@capacitor/core'
const { Share } = Plugins

export default {
  name: 'TemplateItem',
  components: {
  },
  props: {
    extensible: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      isChecked: false,
      url: process.env.VUE_APP_EXT_BASE_URL,
      imageUrl: process.env.VUE_APP_EXT_MEDIA_URL+"/images/",
      videoUrl: process.env.VUE_APP_EXT_MEDIA_URL+"/videos/",
      audioUrl: process.env.VUE_APP_EXT_MEDIA_URL+"/audios/",
      Share: Share,
      isMobileDevice: false,
    }
  },
  computed: {
    ...mapState('newsletter', ['newsletters']),
    ...mapState('user', ['user']),

    getNewsletterNameBySubcode: function () {
        let name = ''
        let self = this
        this.newsletters.forEach(function (newsletter, key) {
            if (self.extensible.subcode === newsletter.subcode) {
                name = newsletter.name
            }
        })
        return name
    }

  },
  created: async function(){
    if (this.extensible.reviews.length < 1) {
      this.loadReviews()
    }
    this.isMobileDevice = await isMobileDevice()
  },
  notifications: {
    onCopyError: {
      title: 'Failed',
      message: 'There was error copying the content',
      type: 'error'
    },
    onCopy: {
      title: 'Success',
      message: 'Content copied',
      type: 'success'
    },
    responseError: {
      title: 'Failed',
      message: 'An error occurred, kindly try again later.',
      type: 'error'
    },
    responseSuccess: {
      title: 'Success',
      message: 'Deleted successfully.',
      type: 'success'
    }
  },
  methods: {
    ...mapActions('extensibleSms', ['fetchReviews', 'delete']),
    toggleSelection: function(flag) {
      this.isChecked = flag
    },
    loadReviews: function () {
      this.fetchReviews({data: {id: this.extensible.id, type: this.extensible.media_type}})
    },
    handleSendAsSMS: function() {
      this.$emit('template-send-as-sms', `${this.extensible.heading}\n${this.url}${this.extensible.slug}`)
    },
    handleMessageDelete: async function() {
      if(!confirm('Sure you want to delete this?'))
        return

      let status = this.delete({data: {id: this.extensible.id, 
                                          type: 'sms', 
                                          uuid: this.user.uuid, 
                                          eType: this.extensible.media_type
                                      }
                                    })
      if (status) {
        this.responseSuccess()
        this.$emit(`deleted-extensible`)
      } else {
        this.responseError()
      }
    },
    handleShare: async function() {
      let shareRet = await Share.share({
        title: this.extensible.heading,
        text: `${this.extensible.heading}`,
        url: `${this.url}${this.extensible.slug}`,
        dialogTitle: 'Share with buddies',
      })
    }
  }
}
</script>

<style scoped>
    .media-size {
        max-height: 500px;
        width: 100%;
    }
</style>
